// src/api/waitlist/waitlist.ts
import { api } from "../api";
import type { WaitlistRequest, WaitlistResponse } from "./waitlist.types";

export const waitlistApi = {
    join: async (payload: WaitlistRequest) => {
        const { data } = await api.post<WaitlistResponse>("/waitlist", payload, {
            headers: { "Content-Type": "application/json" },
        });
        return data;
    },
};